import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Post from "./routes/Post";
import GptPlaygroundThread from "./routes/GptPlaygroundThread";
import AiPlaygroundThread from "./routes/AiPlaygroundThread";
import PinnedDashboards from "./routes/PinnedDashboards";
export default store => ({
  path: "public",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "teacher-course" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Post(store),
    GptPlaygroundThread(store),
    AiPlaygroundThread(store),
    PinnedDashboards(store),
  ],
});
